<template>
  <div class="background-01">
    <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Fin del curso'" videoEmbed="ADMINISTRACIONDINERO57FinDelCurso.mp4"></ui-simple-lsc>
      </v-flex>
    <v-layout row wrap justify-center>
      <ui-title-red textTitle="Fin del curso"></ui-title-red>
      <v-flex xs12 md5 text-xs-center class="animated fadeInLeft">
        <image-app :imaSize="250" imaSrc="contenido/diapositiva_27" imaAlt="Mujer sonriendo recostada en el cuadro de texto"></image-app>
      </v-flex>
      <v-flex xs12 md6 class="aligner animated fadeInUp">
        <div>
          <ui-finalcurso class="animated rotateIn"></ui-finalcurso>    
          <div class="margin-auto">
            <div>
              <audio-player ref="audioPlayer" :audios="[
                'Administracion7.mp3'
                ]"></audio-player>
            </div>         
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.$store.commit("nextShow", false)
    setTimeout(()=>{this.$refs.audioPlayer.playAudio(0)},1000);
  }
}
</script>
<style lang="scss" scoped>
.margin-auto{
  text-align: center;
  &>*{
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// davivienda-57.vue?4c95b290